<template>
  <div>
    <div class="panel-info-section relative-position">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">项目预算明细表</span>
      </div>
      <a-spin :spinning="budgetLoading">
        <div class="v-pa-lg" style="border: 1px solid #eee" v-if="!budget.state">
          <a-empty :image="emptyImage">
            <div slot="description" v-if="budget.state === 0 && budget.checkResult == -1">
              提交的项目预算表已被驳回，
              <span class="text-indigo hover-line" @click="$router.push(`../budget?id=${projectId}`)">重新提交</span>
            </div>
            <div slot="description" v-else-if="budget.files && budget.files.length">
              项目预算表暂存在草稿箱还未提交审核，
              <span class="text-indigo hover-line" @click="$router.push(`../budget?id=${projectId}`)">立即提交</span>
            </div>
            <div slot="description" v-else>
              未提交项目预算表，
              <span class="text-indigo hover-line" @click="$router.push(`../budget?id=${projectId}`)">立即提交</span>
            </div>
          </a-empty>
        </div>
        <template v-else>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th width="160">预算总金额</th>
                <td>
                  <div class="flex items-center">
                    <span>{{ $utils.thousands(budget.amount) }} 元</span>
                    <div class="text-red v-ml-auto" v-if="[1, 2, 3, 4].includes(budget.state)">待审核</div>
                    <div class="v-ml-auto" v-else-if="budget.state == 0 && budget.checkResult == -1">
                      <span class="text-red">已驳回</span>，<span class="text-indigo hover-line" @click="$router.push(`../budget?id=${projectId}`)">重新提交</span>
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <th valign="top">项目预算表</th>
                <td>
                  <file-container :img-size="[100, 55]" :files="budget.files" :belongId="projectId" fileSign="P01" v-if="budget.files && projectId"></file-container>
                </td>
              </tr>
            </tbody>
          </table>
        </template>
      </a-spin>
      <!-- <div class="check-img" v-if="[1, 2, 3].includes(budget.state)">
        <img src="~@/assets/images/audit.png" />
      </div> -->
    </div>
    <div class="panel-info-section">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">财务请款单</span>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="applyId" :loading="applyBillLoading" :pagination="false" :data-source="applyBills" :scroll="{ x: '100%' }">
        <a-table-column title="#" data-index="index" :width="55" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="捐赠物品和服务说明" data-index="serviceDesc" :width="200" :ellipsis="true" align="left" />
        <a-table-column title="请款金额" data-index="applyAmount" :width="120" align="right">
          <template slot-scope="text, record">
            {{ $utils.thousands(record.applyAmount) }}
          </template>
        </a-table-column>
        <a-table-column title="捐赠物品及服务公允值" :width="165" data-index="serviceFairValue" align="right">
          <template slot-scope="text, record">
            {{ $utils.thousands(record.serviceFairValue) }}
          </template>
        </a-table-column>
        <a-table-column title="收款单位/开户行/银行卡号" data-index="bankName" align="left">
          <template slot-scope="text, record">
            <div class="lineh-13">{{ record.billTitle }} / {{ record.bankName }} / {{ record.bankCard }}</div>
          </template>
        </a-table-column>
        <a-table-column title="捐赠凭证" data-index="files" align="left">
          <template slot-scope="text, record">
            <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
          </template>
        </a-table-column>
        <a-table-column title="申请日期" data-index="applyDate" :width="115" align="left">
          <template slot-scope="text, record">
            <template>{{ record.applyDate }}</template>
          </template>
        </a-table-column>
        <a-table-column title="状态" data-index="quantity" :width="80" align="left">
          <template slot-scope="text, record">
            <span v-if="record.state == 0">初稿</span>
            <span v-else-if="record.state == 9">审核通过</span>
            <span class="text-red" v-else>待审核</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="left">
          <template slot-scope="text, record">
            <a-space :size="10">
              <template v-if="record.state === 0">
                <span class="font-xs hover-line text-indigo" title="修改" @click="$router.push(`../applybill/draft?id=${projectId}&aid=${record.applyId}`)">修改</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDelApplyBill(record.applyId)">删除</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`../applybill/detail?id=${projectId}&aid=${record.applyId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <div class="panel-info-section">
      <div class="panel-info-section-title">
        <a-icon type="caret-right" class="text-primary v-mr-xs" />
        <span class="text-bold">财务进展数据</span>
      </div>
      <a-table key="table-edit" class="list-table" size="small" rowKey="billId" :loading="progressBillLoading" :pagination="false" :data-source="progressBills" :scroll="{ x: '100%' }">
        <a-table-column title="#" data-index="index" :width="55" align="center">
          <template slot-scope="text, record, index">
            {{ index + 1 }}
          </template>
        </a-table-column>
        <a-table-column title="报销金额" data-index="billAmount" :width="120" align="left">
          <template slot-scope="text, record">
            {{ $utils.thousands(record.billAmount) }}
          </template>
        </a-table-column>
        <a-table-column title="报销说明" data-index="billRemark" align="left">
          <template slot-scope="text, record">
            <div class="lineh-13 text-ellipsis ellipsis-3-lines" :title="record.billRemark" v-html="$utils.convertToHtml(record.billRemark)"></div>
          </template>
        </a-table-column>
        <a-table-column title="票据文件" data-index="files" align="left">
          <template slot-scope="text, record">
            <file-container :img-size="[100, 55]" :files="record.files" :belongId="projectId" fileSign="P01" v-if="record.files && projectId"></file-container>
          </template>
        </a-table-column>
        <a-table-column title="创建/提交日期" data-index="createTime" :width="115" align="left">
          <template slot-scope="text, record">
            <template v-if="record.state === 0 || record.state === -1">{{ record.createTime ? record.createTime.substring(0, 10) : '' }}</template>
            <template v-else>{{ record.submitTime ? record.submitTime.substring(0, 10) : '' }}</template>
          </template>
        </a-table-column>
        <a-table-column title="状态" data-index="quantity" :width="80" align="left">
          <template slot-scope="text, record">
            <span v-if="record.state == 0">初稿</span>
            <span v-else-if="record.state == 9">审核通过</span>
            <span class="text-red" v-else>待审核</span>
          </template>
        </a-table-column>
        <a-table-column title="操作" data-index="amount" :width="80" align="left">
          <template slot-scope="text, record">
            <a-space :size="6">
              <template v-if="record.state === 0">
                <span class="font-xs hover-line text-indigo" title="修改" @click="$router.push(`../progress/draft?id=${projectId}&bid=${record.billId}`)">修改</span>
                <span class="font-xs hover-line text-red" title="删除" @click="handleDelProgressBill(record.billId)">删除</span>
              </template>
              <span class="font-xs hover-line text-indigo" title="查看" @click="$router.push(`../progress/detail?id=${projectId}&bid=${record.billId}`)" v-else>查看</span>
            </a-space>
          </template>
        </a-table-column>
      </a-table>
    </div>
  </div>
</template>

<script>
import { viewPrj, getBudget } from '@/api/project/house'
import { listApplyBills, delApplyBill, listProgressBills, delProgressBill } from '@/api/project/common'
export default {
  name: 'HouseFinance',
  data() {
    return {
      projectId: null,
      expandedBudgetKeys: [],
      project: {},
      budget: {},
      budgetLoading: false,
      applyBills: [],
      applyBillLoading: false,
      progressBills: [],
      progressBillLoading: false,
    }
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        // this.loadProject()
        this.loadBudget()
        this.loadApplyBills()
        this.loadProgressBills()
      }
    },
    loadProject() {
      viewPrj(this.projectId).then(({ data }) => {
        if (data.success) {
          this.project = data.result
        }
      })
    },
    loadBudget() {
      this.budgetLoading = true
      getBudget(this.projectId).then(({ data }) => {
        if (data.success) {
          this.budget = data.result
        }
        this.budgetLoading = false
      })
    },
    loadApplyBills() {
      this.applyBillLoading = true
      let params = {
        projectId: this.projectId,
        origin: 2,
      }
      listApplyBills(params).then(({ data }) => {
        if (data.success) {
          this.applyBills = data.result
        }
        this.applyBillLoading = false
      })
    },
    loadProgressBills() {
      this.progressBillLoading = true
      let params = {
        projectId: this.projectId,
        origin: 2,
      }
      listProgressBills(params).then(({ data }) => {
        if (data.success) {
          let records = data.result
          // records.forEach(item => {
          //   item.files = item.files
          // })
          this.progressBills = records
        }
        this.progressBillLoading = false
      })
    },
    handleDelApplyBill(applyId) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delApplyBill(applyId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.loadApplyBills()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {})
        },
      })
    },
    handleDelProgressBill(billId) {
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delProgressBill(billId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.loadProgressBills()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {})
        },
      })
    },
  },
  mounted() {
    this.init()
  },
}
</script>
